<template>
  <vxe-modal
    ref="modal"
    v-model="formVisible"
    title="添加备注"
    width="70%"
    height="70%"
    @show="showModal"
  >
    <Editor
      ref="editorBar"
      v-model="form.memo"
      :editorHeight="editorHeight + 'px'"
    />
    <!-- 间隔槽（内含保存按钮） -->
    <div class="buttonContainer">
      <el-button type="primary" @click="save">保存</el-button>
    </div>
  </vxe-modal>
</template>
<script>
export default {
  data() {
    return {
      formVisible: false,
      form: {
        memo: ''
      }
    }
  },
  methods: {
    showModal() {
      this.form = {
        memo: ''
      }
    }
  },
  computed: {
    editorHeight() {
      return Number(this.$store.state.clientHeight) * 0.7 - 43 - 23 - 42 - 5 - 30 - 10
    }
  }
}
</script>
<style lang='less' scoped>
@gap-margin: 10px;
@gap-height: 30px;
.buttonContainer {
  width: 100%;
  height: @gap-height;
  margin: @gap-margin 0 0 0;
  .fl;

  > button {
    padding: 0;
    width: 180px;
    height: 30px;
    font-size: 14px;
    line-height: 30px;
  }
}
</style>